import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';

import EquipmentItem from '~/components/StartList/EquipmentItem';
import { colors, spacing } from '~/utils/css-mixins';
import media from '~/utils/media';

const InfoDiv = styled.div`
  border-bottom: 2px solid ${colors.bgsiteSecondary};
  border-top: 2px solid ${colors.bgsiteSecondary};
  margin: ${spacing.siteGutter * 0.5}px 0 ${spacing.siteGutter}px;
  padding: ${spacing.siteGutter * 0.5}px 0;
  display: flex;
  flex-flow: column wrap;

  ${media.phone`
    flex-direction: row;
  `}
`;

const InfoRow = styled.div`
  margin: 5px 0;
  color: ${colors.textmeta};
  font-size: 14px;
  line-height: 20px;
  white-space: nowrap;
  display: flex;

  ${media.phone`
    margin-right: ${spacing.siteGutter}px;
  `}
`;

const Name = styled.div`
  margin-right: 5px;
`;

const StyledEquipmentItem = styled(EquipmentItem)`
  font-weight: 600;
  color: ${colors.bodyText};
`;

export class PreliminaryEquipment extends PureComponent {
  static propTypes = {
    interview: PropTypes.object.isRequired,
  };
  render() {
    const { preliminary_equipment, previous_start } =
      this.props.interview.start;

    if (
      preliminary_equipment &&
      (preliminary_equipment.shoes ||
        preliminary_equipment.carriage ||
        preliminary_equipment.bridle)
    ) {
      return (
        <InfoDiv>
          {preliminary_equipment.shoes && (
            <InfoRow>
              <Name>Balans:*</Name>
              <StyledEquipmentItem
                type="shoes"
                currentStart={this.props.interview.start}
                preliminaryEquipment={preliminary_equipment}
                previousStart={previous_start}
                showTooltip
              />
            </InfoRow>
          )}
          {preliminary_equipment.carriage && (
            <InfoRow>
              <Name>Vagn:*</Name>
              <StyledEquipmentItem
                type="carriage"
                preliminaryEquipment={preliminary_equipment}
                previousStart={previous_start}
                showTooltip
              />
            </InfoRow>
          )}
          {preliminary_equipment.bridle && (
            <InfoRow>
              <Name>Huvudlag:*</Name>
              <StyledEquipmentItem
                type="bridle"
                preliminaryEquipment={preliminary_equipment}
                previousStart={previous_start}
                showTooltip
              />
            </InfoRow>
          )}
        </InfoDiv>
      );
    }

    return null;
  }
}

export default PreliminaryEquipment;
